import { useEffect } from 'react';

/**
 * Sets document.title and the <meta name="description"> tag for as long as the calling
 * component is mounted, restoring the previous values on unmount — so navigating between
 * routes (Home, a game) updates the tab title/social-preview text per page, without a new
 * dependency like react-helmet (this repo has no existing precedent for one).
 */
export function useDocumentMeta(title: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let meta: HTMLMetaElement | null = null;
    let prevDescription: string | null = null;

    if (description) {
      meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      prevDescription = meta.getAttribute('content');
      meta.setAttribute('content', description);
    }

    return () => {
      document.title = prevTitle;
      if (meta && prevDescription !== null) {
        meta.setAttribute('content', prevDescription);
      }
    };
  }, [title, description]);
}
